const defaultState = {
  isLoading: false,
  counter: 0,
};

const actions = {
  start({ commit }) {
    commit('loadingUpdated', true);
  },
  stop({ commit }) {
    commit('loadingUpdated', false);
  },
};

const mutations = {
  loadingUpdated: (state, isLoading) => {
    state.counter += isLoading ? 1 : -1;
    state.isLoading = isLoading ? true : !state.counter ? false : true;
  },
};

const getters = {
  isLoading: (state) => state.isLoading,
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
